import React from 'react';
import { css } from '@emotion/css';
import Container from 'evcharging/components/Container';
import { Theme } from 'evcharging/app/themes';
import useTheme from 'evcharging/hooks/useTheme';
import Paragraph from 'evcharging/components/Paragraph';
import Spacer from 'evcharging/components/Spacer';
import Box from 'evcharging/components/Box';
import header from 'evcharging/assets/ev-software/header.png';
import software1 from 'evcharging/assets/ev-software/software1.png';
import Responsible from 'evcharging/components/Responsible';
import SoftwareItem, { SoftwareItemProps } from 'evcharging/containers/ev-software/SoftwareItem';
import Desktop from 'evcharging/components/Desktop';
import useI18n from 'evcharging/hooks/useI18n';
import Image from 'next/image';
import { ScreenImage } from 'evcharging/assets/ev-software';

const SoftwareHeader = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();

  const items: SoftwareItemProps[] = [];
  for (let i = 1; i <= 10; i++) {
    items.push({
      title: t(`software.item${i}.title`),
      text: t(`software.item${i}.body`),
      icon: software1,
    });
  }

  return (
    <header className={styles.root}>
      <Container>
        <Spacer value={98} mobile={68} />
        <h1 className={styles.title}>
          {t('software.header1')}
          <br /> {t('software.header2')}
        </h1>
        <Spacer value={16} />
        <Box maxWidth={842} margin={'0 auto'}>
          <Paragraph color={'middle'} textAlign={'center'}>
            {t('software.intro')}
          </Paragraph>
        </Box>
        <Spacer value={43} mobile={24} />
        <Box maxWidth={822} margin={'0 auto'}>
          <Image src={ScreenImage} alt={t('software.alt')} width={852} height={488} />
        </Box>
        <Spacer value={100} mobile={32} />
        <Responsible fractions={Array(4).fill(24)}>
          {items.slice(0, 4).map((item, index) => (
            <SoftwareItem {...item} key={index} />
          ))}
        </Responsible>
        <Responsible fractions={Array(4).fill(24)}>
          {items.slice(4, 8).map((item, index) => (
            <SoftwareItem {...item} key={index} />
          ))}
        </Responsible>
        <Responsible fractions={Array(4).fill(24)}>
          {items.slice(8).map((item, index) => (
            <SoftwareItem {...item} key={index} />
          ))}
          <Desktop>
            <span />
          </Desktop>
          <Desktop>
            <span />
          </Desktop>
        </Responsible>
        <Spacer value={40} mobile={0} />
      </Container>
    </header>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    background-color: #f6f8f9;
    //background-image: url(${header});
    background-size: cover;
    padding-bottom: 98px;
    ${theme.breakpoints.mobile.down} {
      padding-bottom: 0;
    }
  `,
  title: css`
    padding-top: 28px;
    font-weight: 700;
    font-size: 48px;
    line-height: 60px;
    color: #252c32;
    text-align: center;
    ${theme.breakpoints.mobile.down} {
      font-size: 32px;
      line-height: 40px;
    }
  `,
});

export default SoftwareHeader;
